var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdeaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.148,
    height: 25.529,
    viewBox: "0 0 26.148 25.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3,16.179a7.468,7.468,0,0,0-3.736,13.937V32.99a.622.622,0,0,0,.622.622h6.223a.622.622,0,0,0,.622-.622V30.116A7.468,7.468,0,0,0,24.3,16.179Zm2.83,13.012a.625.625,0,0,0-.34.555v2.622H21.813V29.746a.625.625,0,0,0-.34-.555,6.223,6.223,0,1,1,5.66,0Z",
    transform: "translate(-11.229 -10.575)",
    fill: "#fe9920"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.634,36.589H22.9a.623.623,0,0,0,0,1.246h3.736a.623.623,0,0,0,0-1.246Z",
    transform: "translate(-11.69 -12.306)",
    fill: "#fe9920"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.446,23.605a.622.622,0,0,0-.622-.622H11.332a.623.623,0,0,0,0,1.246h2.489a.622.622,0,0,0,.624-.623Z",
    transform: "translate(-10.71 -11.152)",
    fill: "#fe9920"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.314,22.983H35.824a.623.623,0,1,0,0,1.246h2.489a.623.623,0,1,0,0-1.246Z",
    transform: "translate(-12.787 -11.152)",
    fill: "#fe9920"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.939,13.792a.622.622,0,0,0,.622-.622V10.678a.623.623,0,0,0-1.246,0v2.489a.622.622,0,0,0,.623.624Z",
    transform: "translate(-11.863 -10.056)",
    fill: "#fe9920"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.639,16.185a.623.623,0,1,0,.88-.881l-1.762-1.762a.623.623,0,0,0-.88.88Z",
    transform: "translate(-11.047 -10.336)",
    fill: "#fe9920"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.756,30.862a.623.623,0,0,0-.88.881l1.762,1.762a.623.623,0,1,0,.88-.88Z",
    transform: "translate(-12.574 -11.805)",
    fill: "#fe9920"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.958,30.862,14.2,32.624a.623.623,0,0,0,.88.88l1.762-1.762a.623.623,0,0,0-.88-.881Z",
    transform: "translate(-10.99 -11.804)",
    fill: "#fe9920"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.637,16.367a.621.621,0,0,0,.44-.183l1.762-1.762a.623.623,0,1,0-.88-.88L32.2,15.3a.623.623,0,0,0,.44,1.063Z",
    transform: "translate(-12.516 -10.336)",
    fill: "#fe9920"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaIcon);
export default __webpack_public_path__ + "static/media/idea_icon.e85467912eab087daade11a557df316a.svg";
export { ForwardRef as ReactComponent };